import axios from 'axios';
import store from 'store';

async function getAppSettings() {
    try {
        
        const state = store.getState();
        const { identityBaseUrl } = state.auth.aws;
        const fetchUrl = `${identityBaseUrl}/manage/appsetting`;
        return axios.get(fetchUrl,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then((data) => { 
                
                
                return data.data;})
    } catch (error) {
        throw new Error('Error loading app settings');
    }
}

export default getAppSettings;
